// extracted by mini-css-extract-plugin
export default {"button":"HeaderButton_button__Akzm4","icon":"HeaderButton_icon__qLiLw"};